// extracted by mini-css-extract-plugin
module.exports = {"card":"TimedPromotion_card__3APD2","cardDisabled":"TimedPromotion_cardDisabled__3ENAD"};